import React from 'react';
import CrystalGlass from '../../components/glass';

const AntifragileSlide = ({ slide, isBroken }) => {
    return (
        <div className="relative w-full h-full flex flex-col p-12 z-10">
            {/* Header */}
            <div className="flex flex-col gap-2 mb-12">
                <div className="flex items-center gap-4">
                    <div className="h-[2px] w-12 bg-blue-400/50" />
                    <span className="text-blue-400 font-mono tracking-widest uppercase text-lg">
                        Concept
                    </span>
                    <div className="h-[2px] flex-1 bg-gradient-to-r from-blue-400/50 to-transparent" />
                </div>
                <h2 className="text-6xl font-bold leading-[1.4] bg-clip-text text-transparent bg-gradient-to-r from-white via-blue-100 to-blue-200">
                    Antifragilité — Nassim Nicholas Taleb
                </h2>
            </div>

            {/* Content Body */}
            <div className="flex flex-1 items-center gap-12">
                {/* Left: 3 Points */}
                <div className="flex-1 flex flex-col justify-center gap-12 pl-8">
                    {/* Point 1: Fragile */}
                    <div className="group relative pl-8 border-l-2 border-red-500/30 hover:border-red-500 transition-colors duration-500">
                        <div className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-slate-900 border-2 border-red-500/30 group-hover:border-red-500 transition-colors duration-500" />
                        <h3 className="text-3xl font-bold text-red-200 mb-2 opacity-80 group-hover:opacity-100 transition-opacity">Le Fragile</h3>
                        <p className="text-2xl text-slate-300 font-light leading-relaxed">
                            Craint le chaos car il le <span className="text-red-400 font-medium">brise</span>.
                        </p>
                    </div>

                    {/* Point 2: Robuste */}
                    <div className="group relative pl-8 border-l-2 border-slate-500/30 hover:border-slate-400 transition-colors duration-500">
                        <div className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-slate-900 border-2 border-slate-500/30 group-hover:border-slate-400 transition-colors duration-500" />
                        <h3 className="text-3xl font-bold text-slate-200 mb-2 opacity-80 group-hover:opacity-100 transition-opacity">Le Robuste</h3>
                        <p className="text-2xl text-slate-300 font-light leading-relaxed">
                            Encaisse le choc <span className="text-slate-100 font-medium">sans bouger</span>.
                        </p>
                    </div>

                    {/* Point 3: Antifragile */}
                    <div className="group relative pl-8 border-l-2 border-emerald-500/30 hover:border-emerald-500 transition-colors duration-500">
                        <div className="absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-slate-900 border-2 border-emerald-500/30 group-hover:border-emerald-500 transition-colors duration-500" />
                        <h3 className="text-3xl font-bold text-emerald-200 mb-2 opacity-80 group-hover:opacity-100 transition-opacity">L'Antifragile</h3>
                        <p className="text-2xl text-slate-300 font-light leading-relaxed">
                            A besoin du désordre pour <span className="text-emerald-400 font-medium">s'améliorer</span>.
                        </p>
                    </div>
                </div>

                {/* Right: Glass Component */}
                <div className="flex-1 h-full flex items-center justify-center relative">
                    <div className="relative w-full h-full flex items-center justify-center">
                        {/* Background glow for the component */}
                        <div className="absolute w-[500px] h-[500px] bg-blue-500/5 rounded-full blur-3xl pointer-events-none" />
                        <CrystalGlass autoBreak={isBroken} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AntifragileSlide;
